import { styled } from "styled-components";
import { borderRadius } from "polished";
const SegmentedControlItemWrapper = styled("div")(
  {
    borderColor: "#d9d9d9",
    borderStyle: "solid",
    borderWidth: "1px 0",
    flexGrow: 1,
    flexShrink: 1,
    padding: 1,
    position: "relative",
    transition: "all 0.3s cubic-bezier(.645, .045, .355, 1)",
    "&:first-child": {
      borderLeftWidth: 1,
      ...borderRadius("left", 2)
    },
    "&:nth-child(n+2)": {
      marginLeft: -1
    },
    "&:last-child": {
      borderRightWidth: 1,
      ...borderRadius("right", 2)
    },
    "&:focus-within": {
      boxShadow: "0 0 0 2px rgba(0, 0, 0, 0.05)",
      zIndex: 1
    }
  },
  ({ $widthMode }) => $widthMode ? {
    "fill-container": {
      flexBasis: 0,
      width: 0
    },
    "fit-content": {
      flexBasis: "auto"
    }
  }[$widthMode] : void 0
);
const SegmentedControlItemClickArea = styled("button").attrs(({ as }) => ({
  type: !as || as === "button" ? "button" : void 0
}))(({ theme }) => ({
  background: "none",
  border: 0,
  borderRadius: 1,
  cursor: "pointer",
  display: "flex",
  fontFamily: theme.fontFamily.default,
  fontSize: theme.fontSize.default,
  fontWeight: theme.fontWeight.normal,
  height: "100%",
  justifyContent: "center",
  lineHeight: theme.lineHeight.default,
  outline: 0,
  padding: 0,
  position: "relative",
  textDecoration: "none",
  transition: "all 0.3s cubic-bezier(.645, .045, .355, 1)",
  width: "100%",
  "&, &:hover, &:active": {
    color: theme.color.default
  },
  "&:hover": {
    backgroundColor: "rgba(0, 0, 0, 0.05)"
  },
  "&:active": {
    backgroundColor: "#e6e6e6"
  },
  '&[aria-selected="true"]': {
    backgroundColor: "#e2eef4",
    "&, &:hover, &:active": {
      color: theme.color.blue6
    },
    "&:hover": {
      backgroundColor: "#d8e4eb"
    },
    "&:active": {
      backgroundColor: "#a9cade"
    }
  },
  '&[aria-disabled="true"]': {
    cursor: "default",
    "&, &:hover, &:active": {
      backgroundColor: "transparent",
      color: "rgba(0, 0, 0, 0.25)"
    }
  }
}));
const SegmentedControlItemInner = styled("div")(
  {
    alignItems: "stretch",
    display: "flex",
    maxWidth: "100%"
  },
  ({ magnitude }) => ({
    medium: {
      lineHeight: "20px",
      padding: "4px 6px"
    },
    small: {
      lineHeight: "16px",
      padding: "0 4px"
    }
  })[magnitude]
);
const SegmentedControlIcon = styled("div")(
  {
    display: "flex",
    flex: "0 0 auto"
  },
  ({ magnitude }) => ({
    medium: {
      fontSize: 20
    },
    small: {
      fontSize: 16
    }
  })[magnitude]
);
const SegmentedControlText = styled("div")({
  flex: "0 1 auto",
  overflow: "hidden",
  paddingLeft: 6,
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  "&:first-child": {
    paddingLeft: 0
  }
});
export {
  SegmentedControlIcon,
  SegmentedControlItemClickArea,
  SegmentedControlItemInner,
  SegmentedControlItemWrapper,
  SegmentedControlText
};
